import { DateTime } from 'luxon';

export const isToday = (date: Date) => {
  const today = DateTime.local();
  const dateToCheck = DateTime.fromJSDate(date);

  return today.hasSame(dateToCheck, 'day');
};
